<template>
  <div class="tool-bar">
    <b-input-group aria-label="Monitoring search and filter tools">
      <b-form-input
        ref="inputFocus"
        v-model="searchText"
        v-if="!isFiltering || notExists"
        autocomplete="off"
        :placeholder="
          typeFiltering ? `Buscar ${placeholder} ${typeFiltering}` : `Buscar`
        "
        @keyup.enter="searchInList"
        id="INP-search"
        :disabled="notExists || notSearch || isShow"
        size="sm"
      ></b-form-input>
      <b-form-input
        ref="inputFocus"
        v-else
        :placeholder="`Mostrando apenas ${filterOpt}`"
        @keyup.enter="searchInList"
        :readonly="isSearching || isFiltering"
      ></b-form-input>

      <b-input-group-append>
        <b-button
          v-if="isSearching"
          @click="clearSearch"
          variant="danger"
          size="sm"
        >
          <stop-search-icon title="Cancelar busca" />
        </b-button>

        <b-button
          v-else
          :disabled="isFiltering || notSearch"
          @click="searchInList"
          class="search-icon"
          variant="light"
          size="sm"
        >
          <search-icon title="Buscar" />
        </b-button>
        <b-dropdown
          no-caret
          v-if="isMobile && page == 'monit'"
          :disabled="notSearch"
          size="sm"
        >
          <template slot="button-content">
            <filter-icon title="" />
          </template>
          <b-dropdown-item-button
            id="dropdown-header-label"
            @click.prevent="startFilter(100)"
          >
            Sem filtro
          </b-dropdown-item-button>
          <b-dropdown-item-button
            v-for="f in filters"
            :key="f.value"
            @click.prevent="startFilter(f)"
          >
            {{ f.text }}
          </b-dropdown-item-button>
        </b-dropdown>
      </b-input-group-append>
    </b-input-group>

    <!-- <transition-group
      name="staggered-fade"
      tag="ul"
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:leave="leave"
      class="sugestions"
      v-if="sugestionsValues.length > 0 && $route.path !== '/registers/devices'"
    >
      <li
        v-for="(opt, i) in sugestionsValues"
        :key="i"
        @click="selectSugestion(opt)"
        :id="`item-${i}`"
        :data-index="i"
      >
        {{ opt }}
      </li>
    </transition-group> -->

    <div class="row" v-if="isMobile && page == 'regist'">
      <div class="col-xs-12 center-xs qtd-items-top" style="color: white">
        {{ numberOfElements }} equipamentos
      </div>
    </div>

    <div class="register-buttons" v-if="page == 'regist'">
      <schedule-pdf
        v-if="$route.path == '/registers/schedule'"
        :item="toPDF"
        :show-ferti="showFerti"
        :locality="locality"
      />
      <!-- DUPLICATE SCHEDULE -->
      <b-button
        @click="$emit('duplicate')"
        variant="light"
        pill
        v-if="showDuplicateIcon"
        class="ml-1"
      >
        <content-copy title="Duplicar Agenda" />
      </b-button>
      <b-button
        v-if="
          selected.length == 1 &&
          (isAdmin ||
            type == 'schedule' ||
            (type == 'users' && activeUserId == selected[0].ID))
        "
        @click="$emit('edit')"
        pill
        variant="info"
        class="ml-1"
      >
        <pencil-icon title="" />
      </b-button>
      <b-button
        v-if="selected.length && (isAdmin || type == 'schedule')"
        @click="$emit('remove')"
        pill
        variant="danger"
        class="ml-1"
      >
        <delete-icon title="" />
      </b-button>
      <b-button
        v-if="(isAdmin || type == 'schedule') && !hideRegister"
        pill
        variant="3v3"
        @click="$emit('add')"
        class="ml-1"
      >
        <plus-icon title="" />
      </b-button>
    </div>
  </div>
</template>
<script>
import EventBus from "@/pages/components/eventBus";
export default {
  name: "toolbar",
  props: {
    hideRegister: {
      type: Boolean,
      required: false,
      default: false,
    },
    typeFiltering: String,
    show: {
      type: Boolean,
      default: true,
    },
    type: String,
    isSearching: Boolean,
    isMobile: Boolean,
    PDF: Array,
    locality: String,
    selected: Array,
    numberOfElements: Number,
    // allSelected: Boolean,
    isAdmin: Boolean,
    activeUserId: Number,
    filters: Array,
    filterOpt: String,
    isFiltering: Boolean,
    typesOptions: {
      type: Array,
      required: false,
      default: () => {
        return [];
      },
    },
    notSearch: Boolean,
    filterTag: Boolean,
    // type: null,
    notExists: Boolean,
    isShow: Boolean,
    //Filter fertilevel
    showFerti: Boolean,
  },
  created() {
    if (this.$route.path.indexOf("register") > -1) this.page = "regist";
    else if (this.$route.path.indexOf("monitoring") > -1) this.page = "monit";
    else if (this.$route.path.indexOf("monitoring") > -1) this.page = "alerts";
    EventBus.onCleanInputSearch(() => {
      this.searchText = "";
    });
  },
  data() {
    return {
      searchText: "",
      TypeSensorName: "",
      showMobileDrop: false,
      page: "",
    };
  },
  methods: {
    changeTypeSensor(data) {
      this.clearSearch();
      this.$emit("type-change", data);
    },
    resetProp() {
      this.$emit("reset");
    },
    clearText() {
      this.searchText = "";
    },
    focusInInput() {
      this.$refs.inputFocus.focus();
    },
    searchInList() {
      this.$emit("search", this.searchText);
    },
    clearSearch() {
      this.searchText = "";
      this.$emit("clear-search");
    },
    startFilter(f) {
      this.$emit("filter-by", f);
    },
    startFilterType(f) {
      this.$emit("filter-type", f);
    },
    clearFilter() {
      this.searchText = "";
      // this.$emit("filter-by", 100);
      this.$emit("clear-search");
    },
  },
  computed: {
    showMobileDropDown() {
      if (this.isMobile) {
        switch (this.$route.name) {
          case "monitoring-actuators":
            return true;
          case "monitoring-sensors":
            return true;
          case "monitoring-dirs":
            return true;
          case "monitoring-schedule":
            return true;
          default:
            return false;
        }
      }
    },
    showDuplicateIcon() {
      // let isShow=()=>{
      //   let isModel=!!this.type.match(/model/g)
      //   return (
      //     this.selected.length == 1 && !isModel &&
      //     (this.isAdmin ||this.activeUserId == this.selected[0].ID)
      //   );
      // }
      if (this.$route.path == "/registers/schedule") {
        return (
          this.selected.length == 1 &&
          (this.isAdmin ||
            this.type == "schedule" ||
            this.activeUserId == this.selected[0].ID)
        );
      }
      // else if(this.$route.path == "/registers/devices"){
      //   return isShow()
      // }
      // else if(this.$route.path == "/registers/equips"){
      //   return isShow()
      // }
      // else if(this.$route.path == "/registers/sectors"){
      //   return isShow()
      // }
    },
    toPDF() {
      return this.PDF;
    },
    placeholder() {
      let types = [
        "actuators",
        "schedule",
        "sensors",
        "sensors-model",
        "hydros",
        "hydro-model",
        "pumps",
        "actuators-model",
        "model",
        "users",
        "group",
        "sectors",
      ];
      let tipos = [
        "atuador",
        "agenda",
        "sensor",
        "modelo de sensor",
        "hidrômetro",
        "modelo de hidrômetro",
        "bomba",
        "modelo de atuador",
        "modelo de dir",
        "usuário",
        "grupo",
        "setor",
      ];
      return tipos[types.indexOf(this.type)] || "";
    },
  },
};
</script>
<style scoped>
.btn-light {
  background-color: #dadada !important;
  border: none;
  transition: all 0.2s ease;
}
.btn-light:hover {
  background-color: #cacaca !important;
}

.sugestions {
  position: absolute;
  left: 2.8%;
  width: 92%;
  z-index: 999;
  background-color: #ffffff;
  border-radius: 0 0 8px 8px;
  list-style: none;
  font-size: 0.9em;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.15);
  text-align: left;
  max-height: 300px;
  overflow-y: auto;
  padding: 4px 0px 0 0px;
  border-bottom: 7px solid var(--green-3v3);
  transition: all ease 0.5s;
}
.sugestion-item-active {
  background-color: #f3f3f3;
  /* border-radius: 4px; */
}
.sugestions li {
  transition: all ease 0.1s;
  cursor: pointer;
  width: 100%;
  padding: 4px 8px;
}
.sugestions li:hover {
  /* border-radius: 4px; */
  background-color: #dfdfdf;
}

@media screen and (max-width: 767px) {
  .qtd-items-top {
    font-size: 0.95em;
  }
}
</style>
